<div id="service">
    <div id="marco">
        <img id="torta" src="{{image}}" alt="">
    </div>
    <div id="texto">
        <h3 id="title"> {{title}} </h3>
        <p id="description">{{text}}</p>
    </div>
    <p (click)="onClick()" id="texto1">SABER MÁS</p>
</div>